export const StandardMaxOrderedSetSize = 5;

export class OrderedSet<T> {
    orderedArray: T[];

    // Max that we will 'save'/'store'
    maxArraySize: number;
    // Max that we will allow callers to get access to
    accessibleArraySize: number;

    constructor(
        array: T[],
        maxCountOfItems: number = StandardMaxOrderedSetSize,
        numberOfAccessibleElements: number = null
    ) {
        this.orderedArray = array;
        this.maxArraySize = maxCountOfItems;

        this.accessibleArraySize = numberOfAccessibleElements
            ? numberOfAccessibleElements
            : maxCountOfItems;
    }

    updateArrayTop(element: T, find?: (arrayItem: T, elem: T) => boolean) {
        if (this.orderedArray) {
            this.orderedArray = this.orderedArray.filter((item) =>
                // Note: 'find' is the function, potentially, passed in. Used for non-simple item types
                find ? !find(item, element) : item !== element
            );

            this.orderedArray.unshift(element);
            if (this.orderedArray.length > this.maxArraySize) {
                this.orderedArray.splice(this.maxArraySize);
            }
        }
    }

    removeElement(find: (arrayItem: T) => boolean) {
        const index = this.orderedArray.findIndex((item) => find(item));

        if (index !== -1) {
            return this.orderedArray.splice(index, 1)[0];
        }
        return null;
    }

    clear() {
        this.orderedArray.length = 0;
    }

    first(): T {
        return this.orderedArray[0];
    }

    getArray(): T[] {
        return this.orderedArray.slice(0, this.accessibleArraySize);
    }
}
